var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.475 11.4063C33.2283 5.08134 27.6733 0.333008 21 0.333008C15.7017 0.333008 11.1 3.33967 8.80833 7.73967C3.29 8.32634 -1 13.0013 -1 18.6663C-1 24.7347 3.93167 29.6663 10 29.6663H33.8333C38.8933 29.6663 43 25.5597 43 20.4997C43 15.6597 39.2417 11.7363 34.475 11.4063ZM24.6667 16.833V24.1663H17.3333V16.833H11.8333L21 7.66634L30.1667 16.833H24.6667Z",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.1c665288e3213c46998f54ee936bb7be.svg";
export { ForwardRef as ReactComponent };